import React from 'react';
import { PureComponent } from '../../../dispatcher/modules';
import { ICON_COMPONENT_PROPS, ICON_OMITTED_PROPS } from './Types';
import classNames from 'classnames';
import WithTooltip from '../../../utility/withTooltip';
import { TOOLTIP_OMITTED_PROPS } from '../../../utility';
import * as _ from 'lodash';
import PuzzleTooltip from '../tooltip/PuzzleTooltip';

class IconComponent extends PureComponent<ICON_COMPONENT_PROPS> {
  tooltip: any = null;

  static defaultProps = {
    color: 'default',
    className: '',
    size: 'medium',
    tooltipOpenDelay: 1000,
    tooltipAnchor: 'target',
    tooltipPosition: 'top'
  };

  render(): any {
    const {
      size = 'medium',
      color = 'default',
      name = '',
      className = '',
      dataCy,
      titleText,
      tooltipAnchor = 'target',
      tooltipContent,
      tooltipOpenDelay = 1000,
      tooltipPosition = 'top',
      tooltipClassName = '',
      withTooltip,
      style
    } = this.props;

    const colorAsArray = _.isArray(color) && color.length === 2;
    const omittedProps:ICON_OMITTED_PROPS = _.omit(this.props, ['size', 'color', 'name', 'dataCy', ...TOOLTIP_OMITTED_PROPS]);
    const iconClassName = classNames(
      `tp-icon-component ${className} tp-icon`,
      {
        'tp-icon-xs': size === 'xSmall',
        'tp-icon-sm': size === 'small',
        'tp-icon-md': size === 'medium',
        'tp-icon-l': size === 'large',
        'tp-icon-xl': size === 'xLarge',
        'tp-color-default': color === 'default',
        'tp-color-accent': color === 'accent',
        'tp-color-success': color === 'success',
        'tp-color-error': color === 'error',
        [`tp-${name}`]: name,
        [`tp-color-${color[0]}-${color[1]}`]: colorAsArray && color
      }
    );

    const content = (
      <i
        {...omittedProps}
        style={{
          ...style,
          width: size,
          height: size,
          fontSize: size
        }}
        data-cy={dataCy}
        className={iconClassName}
        title={titleText}
        tabIndex={withTooltip ? 0 : null}
      />
    );

    if (withTooltip) {
      return (
        <>
          <WithTooltip
            className={tooltipClassName}
            context={this}
            title={titleText}
            htmlTag={'span'}
          >
            {content}
          </WithTooltip>
          <PuzzleTooltip
            anchorElement={tooltipAnchor}
            ref={(el: any) => this.tooltip = el}
            openDelay={tooltipOpenDelay}
            position={tooltipPosition}
            content={tooltipContent}
          />
        </>
      );
    }
    return content;
  }
}

export default IconComponent;
